class OriginalSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if (window.matchMedia('(max-width: 767px)').matches) {
      const swiper = new Swiper('.case-og-swiper', {
        speed: 500,
        loop: true,
        spaceBetween: 30,
        slidesPerView: "auto",
        autoplay: {
          delay: 2000,
        },
      })
    }
  }
}